<template>
  <b-modal @ok="e => {ok(e)}"
           @hide="e => {hide(e)}"
           @cancel="e => {cancel(e)}"
           @hidden="e => {hidden(e)}"
           v-model="show"
           ok-variant="secondary"
           cancel-variant="outline-info"
           :ok-title="confirm"
  >
    <template slot="modal-title">
      <h5 class="text-uppercase text-dark font-weight-normal mb-0">{{title}}</h5>
    </template>
    <slot name="body"></slot>
  </b-modal>
</template>

<script>
  import i18n from '@/utils/i18n';

  export default {
    props: {
      name: {
        type: String
      },
      confirm: {
        type: String,
        default: i18n.t('button.delete')
      },
      showModal: {
        type: Boolean
      },
      title: {
        type: String
      },
      preventHideOnOk: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        show: false,
        index: null
      }
    },
    mounted () {
      this.$bus.$on(`open${this.name}Modal`, (index) => {
        this.index = index;
        this.show = true
      });
      this.$bus.$on(`close${this.name}Modal`, () => {
        this.show = false
      });
    },
    methods: {
      ok (e) {
        if (this.preventHideOnOk) {
          e.preventDefault();
        }
        this.$emit('ok', this.index)
      },
      hide () {
        this.$emit('hide');
      },
      hidden () {
        this.$emit('hidden');
      },
      cancel () {
        this.$emit('cancel')
      }
    },
    destroyed () {
      this.$bus.$off(`open${this.name}Modal`);
      this.$bus.$off(`close${this.name}Modal`)
    },
    watch : {
      showModal () {
        this.show = this.showModal
      }
    }
  }
</script>
